import React from 'react';
import { MapPin, Phone, MessageCircle, Clock, CreditCard, Truck, Store } from 'lucide-react';
import { businessInfo } from '@/data/menuData';
import { FooterAdminLink } from '@/components/FooterAdminLink';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground px-4 py-10 pb-32 text-primary-foreground md:pb-10">
      <div className="mx-auto max-w-4xl">
        <div className="mb-8 flex flex-col items-center">
          <img
            src={businessInfo.logo}
            alt={businessInfo.name}
            className="mb-4 h-20 w-20 rounded-full border-4 border-primary-foreground/20 object-cover"
          />
          <h3 className="text-2xl font-bold">{businessInfo.name}</h3>
          <p className="text-sm text-primary-foreground/70">{businessInfo.slogan}</p>
        </div>

        <div className="mb-8 flex flex-wrap justify-center gap-3">
          <div className="flex items-center gap-2 rounded-full bg-instagram-purple/20 px-4 py-2 text-sm">
            <Store className="h-4 w-4" />
            <span>Ritiro in Sede</span>
          </div>
          <div className="flex items-center gap-2 rounded-full bg-success/20 px-4 py-2 text-sm">
            <Truck className="h-4 w-4" />
            <span>Consegna a Domicilio</span>
          </div>
          <div className="flex items-center gap-2 rounded-full bg-instagram-orange/20 px-4 py-2 text-sm">
            <CreditCard className="h-4 w-4" />
            <span>Pagamento con Carta</span>
          </div>
        </div>

        <div className="mb-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          <a
            href={businessInfo.googleMapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-start gap-3 rounded-lg bg-primary-foreground/5 p-4 transition-colors hover:bg-primary-foreground/10"
          >
            <MapPin className="mt-0.5 h-5 w-5 flex-shrink-0 text-instagram-orange" />
            <div>
              <p className="mb-1 text-sm font-medium">Indirizzo</p>
              <p className="text-sm text-primary-foreground/70">{businessInfo.address}</p>
            </div>
          </a>

          <a
            href={`tel:${businessInfo.phone}`}
            className="flex items-start gap-3 rounded-lg bg-primary-foreground/5 p-4 transition-colors hover:bg-primary-foreground/10"
          >
            <Phone className="mt-0.5 h-5 w-5 flex-shrink-0 text-instagram-purple" />
            <div>
              <p className="mb-1 text-sm font-medium">Telefono</p>
              <p className="text-sm text-primary-foreground/70">{businessInfo.phoneDisplay}</p>
            </div>
          </a>

          <a
            href={`https://wa.me/${businessInfo.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-start gap-3 rounded-lg bg-primary-foreground/5 p-4 transition-colors hover:bg-primary-foreground/10"
          >
            <MessageCircle className="mt-0.5 h-5 w-5 flex-shrink-0 text-success" />
            <div>
              <p className="mb-1 text-sm font-medium">WhatsApp</p>
              <p className="text-sm text-primary-foreground/70">{businessInfo.whatsapp}</p>
            </div>
          </a>

          <div className="flex items-start gap-3 rounded-lg bg-primary-foreground/5 p-4">
            <Clock className="mt-0.5 h-5 w-5 flex-shrink-0 text-instagram-red" />
            <div>
              <p className="mb-1 text-sm font-medium">Orari Ordini</p>
              <p className="text-sm text-primary-foreground/70">Lun-Sab 09:00-20:30</p>
              <p className="mt-1 text-xs text-primary-foreground/50">Orario continuato</p>
            </div>
          </div>
        </div>

        <div className="mb-6 h-px bg-primary-foreground/10" />

        <div className="space-y-3 text-center">
          <p className="text-xs text-primary-foreground/50">
            Menu digitale proprietario • Nessuna piattaforma terza • Pagamenti sicuri con Stripe
          </p>

          <p className="text-sm text-primary-foreground/70">
            © {currentYear} {businessInfo.name}. Tutti i diritti riservati.
          </p>

          <p className="text-xs text-primary-foreground/40">
            Realizzato con amore da{' '}
            <a
              href="https://www.ducawebstudio.com"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:text-primary-foreground"
            >
              ducawebstudio.com
            </a>{' '}
            per la tradizione pugliese
          </p>

          <div className="border-t border-primary-foreground/5 pt-4">
            <FooterAdminLink />
          </div>
        </div>
      </div>
    </footer>
  );
};
